
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const lineitemApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listLineItems: builder.query ({
      query: (params) => `v2/lineitem/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["LineItem"]
    }),
    getLineItem: builder.query ({
      query: (lineitem_id) => `v2/lineitem/${lineitem_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["LineItem"]
    }),
    getLineItemLayouts: builder.query ({
      query: (lineitem_id) => `v2/layout/?lineitem=${lineitem_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["Layout"]
    }),
    getLineItemInstances: builder.query ({
      query: (lineitem_id) => `v2/itemonplate/?lineitem=${lineitem_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["ItemOnPlate"]
    }),
    getLineItemRemakes: builder.query ({
      query: (lineitem_id) => `v2/remake/?lineitem=${lineitem_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["Remake"]
    }),
    getLineItemActions: builder.query ({
      query: (lineitem_id) => `v2/action/?lineitem=${lineitem_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["Action"]
    }),
    getLineItemNotes: builder.query ({
      query: (lineitem_id) => `v2/note/?lineitem=${lineitem_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["Note"]
    }),
    getLineItemPhotos: builder.query ({
      query: (lineitem_id) => `v2/photo/?order=${lineitem_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["Photo"]
    }),
    updateLineItem: builder.mutation ({
      query: ({lineitem_id, data}) => ({
        url: `v2/lineitem/${lineitem_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["LineItem"]
    }),
    deleteLineItem: builder.mutation ({
      query: (lineitem_id) => ({
        url: `v2/lineitem/${lineitem_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["LineItem"]
    }),
    createLineItem: builder.mutation ({
      query: (data) => ({
        url: `v2/lineitem/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["LineItem"]
    }),
  })
})


export const {
  useListLineItemsQuery,
  useLazyListLineItemsQuery,
  useGetLineItemQuery,
  useLazyGetLineItemQuery,
  useGetLineItemLayoutsQuery,
  useGetLineItemInstancesQuery,
  useGetLineItemRemakesQuery,
  useGetLineItemActionsQuery,
  useGetLineItemNotesQuery,
  useGetLineItemPhotosQuery,
  useUpdateLineItemMutation,
  useDeleteLineItemMutation,
  useCreateLineItemMutation
} = lineitemApi
